
    var riot = require('riot')
    //src: starling/src/tags/lightbox.html
riot.tag2('lightbox',
  '<div class="modal-background" onclick="{dismiss}" style="display: none;"></div> <div class="modal fade" onclick="{dismiss}" tabindex="-1" role="dialog" style="display: none;"> <div class="modal-dialog" role="document"> <div class="modal-content"> <img if="{this.imageType === \'image\'}" ref="image" riot-src="{imgSrc}"> <video if="{this.imageType === \'video\'}" ref="video" loop="{this.loop ? \'loop\' : \'\'}" controls="{this.showControls}" riot-src="{imgSrc}"></video> <object if="{this.imageType === \'pdf\'}" ref="pdf" type="application/pdf" data="{imgSrc}" height="100%" width="100%"></object> </div> </div> </div> </div>',
  '',
  'class="lightbox" ref="root"', function(opts) {
'use strict';

var _this = this;

var self = this;
this.canvas = this.opts.canvas;
this.operation = this.canvas.operation;
this.canvas.lightbox = this;
this.imgSrc = '';

this.show = function (imgSrc, opts) {
  document.body.classList.add("lightbox-active");
  document.addEventListener('keyup', _this.handleKeyup);
  _this.hideContent();
  _this.imgSrc = imgSrc;

  var getImageType = function getImageType(imageType) {
    switch (imageType) {
      case 'video':
        return 'video';
      case 'pdf':
        return 'pdf';
      default:
        return 'image';
    }
  };

  _this.imageType = getImageType(opts.imageType);
  _this.showControls = opts.showControls;
  _this.loop = opts.loop;

  _this.update();
  $('lightbox .modal-background').fadeIn();
  $('lightbox .modal').fadeIn();
  _this.showContent();
  if (_this.imageType === 'video' && opts && opts.autoPlay) {
    _this.playVideo();
  }
};

this.dismiss = function (e) {
  document.body.classList.remove("lightbox-active");
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  document.removeEventListener('keyup', _this.handleKeyup);
  _this.hideContent();
  if (_this.refs.video) {
    _this.refs.video.pause();
  }
  $('.modal-background').fadeOut();
  $('.modal').fadeOut();
};

this.playVideo = function () {
  _this.refs.video.currentTime = 0;
  _this.refs.video.play();
};

this.handleKeyup = function (e) {
  _this.dismiss();
};

this.hideContent = function () {
  if (_this.refs.image) {
    _this.refs.image.classList.add('hidden');
  } else if (_this.refs.video) {
    _this.refs.video.classList.add('hidden');
  } else if (_this.refs.pdf) {
    _this.refs.pdf.classList.add('hidden');
  }
};

this.showContent = function () {
  if (_this.refs.image) {
    _this.refs.image.classList.remove('hidden');
  } else if (_this.refs.video) {
    _this.refs.video.classList.remove('hidden');
  } else if (_this.refs.pdf) {
    _this.refs.pdf.classList.remove('hidden');
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('lightbox')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/lightbox.html
// module id = 635
// module chunks = 0